import styled from "styled-components";
import { COMPONENTS, SPACING } from "../../constants/design/spacing";

export const PositionsWrapper = styled.div`
  > * {
    overflow: hidden;
    margin: ${SPACING.two}px;
  }
`;
